var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.380859,
    width: 17.22,
    height: 17.03,
    rx: 8.515,
    fill: "#FF666F",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 10.3809L8.09 5.38086H9.07L8.96 10.3809H8.2ZM9.22 11.7909C9.22 12.1409 8.95 12.4109 8.62 12.4109C8.27 12.4109 8 12.1409 8 11.7909C8 11.4409 8.27 11.1709 8.62 11.1709C8.95 11.1709 9.22 11.4409 9.22 11.7909Z",
    fill: "#FF434E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/infoRed.eb604effc3c35f92da30888d65b3d4bf.svg";
export { ForwardRef as ReactComponent };